import Echo from 'laravel-echo'
import { getBroadcastTenant } from '../helpers/general'

class EchoService {
  constructor() {
    this.echo = null
    this.reconnectAttempts = 0
    this.MAX_RECONNECT_ATTEMPTS = 5
    this.RECONNECT_DELAY = 2000
    this.connections = new Map()
    this.connectionStatus = 'disconnected'
  }

  initialize() {
    const token = localStorage.getItem('token')

    this.echo = new Echo({
      broadcaster: 'pusher',
      key: import.meta.env.VITE_REVERB_APP_KEY,
      wsHost: import.meta.env.VITE_REVERB_HOST,
      wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
      wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
      forceTLS: false,
      encrypted: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      cluster: 'eu',
      auth: {
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }
    })

    this.setupConnectionHandlers()
    window.Echo = this.echo
    return this.echo
  }

    updateToken(newToken) {
        if (this.echo && this.echo.connector) {
            this.echo.connector.options.auth.headers['Authorization'] = `Bearer ${newToken}`
            this.echo.connector.pusher.disconnect()
            this.echo.connector.pusher.connect()
        }
    }

    setupConnectionHandlers() {
    this.echo.connector.pusher.connection.bind('connected', () => {
      this.connectionStatus = 'connected'
      this.reconnectAttempts = 0
      this.resubscribeAll()
    })

    this.echo.connector.pusher.connection.bind('disconnected', () => {
      this.connectionStatus = 'disconnected'
      this.handleDisconnect()
    })

    this.echo.connector.pusher.connection.bind('error', (error) => {
      console.error('Echo connection error:', error)
      this.handleDisconnect()
    })
  }

  handleDisconnect() {
    if (this.reconnectAttempts >= this.MAX_RECONNECT_ATTEMPTS) {
      console.error('Max reconnection attempts reached')
      return
    }

    this.reconnectAttempts++
    setTimeout(() => {
      console.log(`Attempting to reconnect, attempt ${this.reconnectAttempts}`)
      this.initialize()
    }, this.RECONNECT_DELAY * this.reconnectAttempts)
  }

  subscribeToTraining(userId) {
    const tenant = getBroadcastTenant()
    const channelName = `training.${tenant}.${userId}`

    if (this.connections.has(channelName)) {
      return this.connections.get(channelName)
    }

    const connection = this.echo.private(channelName)
    this.connections.set(channelName, connection)
    return connection
  }

  resubscribeAll() {
    this.connections.forEach((connection, channelName) => {
      const userId = channelName.split('.')[2]
      this.subscribeToTraining(userId)
    })
  }

  unsubscribeFromTraining(userId) {
    const tenant = getBroadcastTenant()
    const channelName = `training.${tenant}.${userId}`

    if (this.connections.has(channelName)) {
      const connection = this.connections.get(channelName)
      connection.unsubscribe()
      this.connections.delete(channelName)
    }
  }
}

export const echoService = new EchoService()
